import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoadingState } from "./components/StateViews";
import { useAuth } from "./contexts/AuthContext";
import { appConfig, hasSupabaseConfig } from "./lib/config";
import { IntelligencePage } from "./pages/IntelligencePage";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { PortfolioPage } from "./pages/PortfolioPage";
import { RadarPage } from "./pages/RadarPage";
import { ReportsPage } from "./pages/ReportsPage";
import { SeedPage } from "./pages/SeedPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SetupPage } from "./pages/SetupPage";

function ProtectedRoutes() {
  const auth = useAuth();
  if (auth.loading)
    return (
      <div className="fullscreen-state">
        <LoadingState label="Abrindo a Estufa…" />
      </div>
    );
  if (!appConfig.demoMode && !hasSupabaseConfig) return <SetupPage />;
  if (!auth.demo && !auth.session) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/portfolio/:seedId" element={<SeedPage />} />
        <Route path="/radar" element={<RadarPage />} />
        <Route path="/intelligence" element={<IntelligencePage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={<ProtectedRoutes />} />
    </Routes>
  );
}
